<div class="position-relative">
  <button
    *ngIf="show_nav_btns"
    class="d-none d-lg-flex position-absolute align-items-center justify-content-center swiper-btn-prev elevate-white"
    aria-label="Previous"
    (click)="slidePrev()"
  >
    <span class="material-icons">chevron_left</span>
  </button>

  <swiper-container #swiperContainer init="false">
    <swiper-slide *ngFor="let action of order_center_actions">
      <div
        as-button
        class="card text-center elevate-white h-100 order-action-card"
        tabindex="0"
        [attr.aria-label]="action?.name"
        (click)="onItemClick(action)"
      >
        <div class="card-body d-flex flex-column justify-content-center pt-2">
          <div class="">
            <span class="{{ action?.additional_info?.image_info?.class }}">
              {{ action?.additional_info?.image_info?.material_icon_class }}
            </span>
          </div>
          <div class="d-flex justify-content-center">
            <span class="fw-normal">
              {{ action?.name }}
            </span>
          </div>
        </div>
      </div>
    </swiper-slide>
  </swiper-container>

  <button
    *ngIf="show_nav_btns"
    class="d-none d-lg-flex position-absolute align-items-center justify-content-center swiper-btn-next elevate-white"
    aria-label="Next"
    (click)="slideNext()"
  >
    <span class="material-icons">chevron_right</span>
  </button>
</div>
